export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const getFirstCharOfAstring = (text: string) => {
  return text?.split("")?.[0].toUpperCase();
};

export const capitalizeFirstLetter = (str: string) => {
  const text = str.toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getLastElementSplited = (str: string, splitedChar?: string) => {
  const elems = str.split(splitedChar ?? "");
  return elems?.[elems?.length - 1];
};
